// The settings home: the search, centred a little way down the page, and under
// it either a small card per group or, while there is a search, what it found.
// The search keeps its place as results replace the cards. The rail names the
// page, so its heading is for assistive tech only.
import { phAttrs } from "../../lib/analytics/attrs.js";
import { ATTRIBUTE } from "../../lib/analytics/surfaceVocabulary.js";
import { SearchField } from "./SettingsTop.jsx";

function Cards({ groups, onOpen, waiting }) {
    return (
        <div className="grid w-full auto-rows-fr grid-cols-4 gap-[10px] max-[960px]:grid-cols-3 max-[720px]:grid-cols-2 max-[440px]:grid-cols-1" data-settings-cards="">
            {groups.map((group) => (
                <button
                    key={group.id}
                    type="button"
                    onClick={() => onOpen(group.id)}
                    {...phAttrs({ [ATTRIBUTE.SETTING]: group.id })}
                    data-settings-group={group.id}
                    className="group relative flex min-h-[104px] min-w-0 cursor-pointer flex-col gap-[6px] rounded-[10px] border border-[color:var(--line)] bg-[color:var(--bg)] px-[14px] pb-[14px] pt-[13px] text-left transition-colors duration-150 hover:border-[color:var(--line-strong)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[color:var(--green)] motion-reduce:transition-none"
                >
                    <svg viewBox="0 0 12 12" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" className="absolute right-[11px] top-[11px] h-[11px] w-[11px] text-[color:var(--muted-soft)] transition-colors group-hover:text-[color:var(--green)] group-focus-visible:text-[color:var(--green)] motion-reduce:transition-none">
                        <path d="M3 9l6-6M3 3h6v6" />
                    </svg>
                    <h2 className="m-0 min-w-0 pr-[16px] text-[13.5px] font-medium leading-[1.35] text-[color:var(--ink)]">{group.name}</h2>
                    <p className="m-0 text-[12.5px] leading-[1.45] text-[color:var(--muted)]">{group.peek}</p>
                    {group.id === "access" && waiting > 0 ? (
                        <span className="mt-auto pt-[6px] text-[12px] text-[color:var(--ink)]">
                            {waiting === 1 ? "1 elevation request waiting" : `${waiting} elevation requests waiting`}
                        </span>
                    ) : null}
                </button>
            ))}
        </div>
    );
}

export default function SettingsHome({ groups, onOpen, waiting, query, onQuery, searchRef, results = null }) {
    return (
        <div className="flex flex-1 flex-col items-center pb-[34px] pt-[min(12vh,104px)] max-[560px]:pt-[24px]">
            <h1 className="sr-only">Settings</h1>
            <div className="grid w-full max-w-[760px] gap-[26px]">
                <SearchField value={query} onChange={onQuery} inputRef={searchRef} large />
                {results ?? <Cards groups={groups} onOpen={onOpen} waiting={waiting} />}
            </div>
        </div>
    );
}
